import Lottie from 'react-lottie';
import Icon from '@components/common/assets';
import fireCracker from '@graphic/fireCracker.json';
import { useDchampsFinalsApply, useDchampsInfo, useDhampsFinalsCheck } from '@repository/dchamps/useDchamps';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Colors from '@domain/constant/colors';
import { DchampsEventType } from '@domain/constant/dchamps/eventType';
import { V2Route } from '@utils/routeUtil';
import useDebounce from '@utils/hooks/useDebounce';
import classnames from 'classnames/bind';
import styles from './finalJoin.module.scss';
import DateUtil from '@utils/date/util';
import DateFormat from '@utils/date/format';
import UrlUtil from '@utils/urlUtil';

const cx = classnames.bind(styles);

const visualOptions = {
  loop: true,
  autoplay: false,
  animationData: fireCracker,
};

const DchampsFinalJoin = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { data: dchampsInfo } = useDchampsInfo();
  const eventType = dchampsInfo?.progressFinal?.eventType;
  const { data: isFinalist } = useDhampsFinalsCheck(isLogin && !!eventType, eventType as DchampsEventType);
  //본선진출자이고 다음 예선이 현재 본선과 다른경우 본선 카운트다운을 보여줌.
  const isVisible =
    dchampsInfo?.progressFinal &&
    isFinalist &&
    dchampsInfo?.progressQualify?.eventType !== dchampsInfo.progressFinal.eventType;
  const finalsStartDateTime = dchampsInfo?.progressFinal?.startDateTime ?? new Date();
  const { mutateAsync: createDchampsFinalsApply } = useDchampsFinalsApply();

  //30분 전부터 입장 가능
  const isJoinableFinalTest = () => {
    const currentDate = DateUtil.getNow();
    const thirtyMinutesLater = new Date(currentDate.getTime() + 30 * 60 * 1000);

    return DateUtil.compare(thirtyMinutesLater, finalsStartDateTime) >= 0;
  };

  const onClickJoinBtn = useDebounce(async () => {
    if (!userData || !isFinalist || !isJoinableFinalTest() || !eventType) return null;
    const rs = await createDchampsFinalsApply(eventType);

    UrlUtil.openWindowWithPost(V2Route.getPHSApplyApiPage(rs.url), {
      examCode: rs.code,
      name: userData.name,
    });
  }, 1000);

  const dateText = DateFormat.format(
    finalsStartDateTime,
    'yyyy년 MM월 dd일 AP H시 mm분 본선 시작 (30분 전부터 입장할 수 있어요.)',
  );

  if (!isVisible) return null;

  return (
    <div className={cx('joinArea')}>
      <div className={cx('joinInfo')}>
        <div className={cx('lottieWrap')}>
          <Lottie options={visualOptions} />
        </div>
        <div className={cx('textArea')}>
          <strong className={cx('title')}>디챔스 본선 진출을 축하합니다!</strong>
          <span className={cx('date')}>{dateText}</span>
        </div>
      </div>
      <a className={cx('joinBtn')} role="button" onClick={onClickJoinBtn}>
        본선 참여하기
        <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_WHITE} />
      </a>
    </div>
  );
};

export default DchampsFinalJoin;
